import { Api } from '@/interface/api';

/**
 * 查询资质
 */
const enterpriseGetCertificationTypeAndCerTypeOptions: Api = {
    url: '/api/project/proxy-token/api/enterprise/getCertificationTypeAndCerTypeOptions',
    method: 'get',
};

/**
 * 查询资质申请
 */
const enterpriseGetApply: Api = {
    url: '/api/project/proxy-token/api/enterprise/getApply',
    method: 'get',
};

/**
 * 资质申请
 */
const enterpriseCreateApply: Api = {
    url: '/api/project/proxy-token/api/enterprise/createApply',
    method: 'post',
};

/**
 * 资质图片上传
 */
const enterpriseUploadAuthAction: Api = {
    url: '/api/project/proxy-token/api/enterprise/uploadAuthAction',
    method: 'post',
};

export {
    enterpriseGetCertificationTypeAndCerTypeOptions,
    enterpriseGetApply,
    enterpriseCreateApply,
    enterpriseUploadAuthAction,
};
